<template>
    <div class="container admin-table-page">

        <!-- =====================================================
             TÍTULO
        ====================================================== -->
        <div class="param-title-wrap niif-header">

            <div class="d-flex align-items-center w-100">

                <div class="d-flex align-items-center">

                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>

                    <h2 class="param-title">
                        {{ labels.title }}
                    </h2>

                </div>

            </div>

        </div>


        <!-- =====================================================
             FECHA CONTABILIZACIÓN
        ====================================================== -->
        <div class="param-title-wrap niif-header mt-3">

            <div class="d-flex align-items-center w-100">

                <div class="filters-container d-flex align-items-center">

                    <!-- FECHAS EXISTENTES -->
                    <select
                        v-if="fechasParamContab?.length >= 1"
                        v-model="fechaContabilizacion"
                        class="form-control mx-3"
                        style="width: 210px;"
                    >

                        <option value="">
                            {{ labels.fechaContabilizacion }}
                        </option>

                        <option
                            v-for="item in fechasParamContab"
                            :key="item?.id"
                            :value="item?.fecha_contabilizacion"
                        >
                            {{ item?.fecha_contabilizacion }}
                        </option>

                    </select>


                    <!-- SI NO EXISTEN FECHAS -->
                    <input
                        v-else
                        v-model="fechaContabilizacion"
                        type="month"
                        class="form-control mx-3"
                        style="width: 210px;"
                    />


                    <!-- NUEVA FECHA -->
                    <b-button
                        v-if="fechasParamContab?.length >= 1"
                        class="table-toolbar-add-btn"
                        @click="creaParamContab"
                        title="Crear nueva parametrización"
                    >

                        <font-awesome-icon
                            :icon="['fas', 'plus']"
                        />

                    </b-button>


                    <!-- INPUT NUEVA FECHA -->
                    <div
                        v-if="showNewContab"
                        class="fecha-input-wrapper"
                    >

                        <input
                            v-model="newFechaContab"
                            type="month"
                            class="form-control"
                        />

                        <span
                            v-if="!newFechaContab"
                            class="fecha-placeholder"
                        >
                            {{ labels.newFechaContab }}
                        </span>

                    </div>


                    <!-- CANCELAR NUEVA FECHA -->
                    <b-button
                        v-if="showNewContab"
                        class="table-toolbar-delete-btn"
                        variant="danger"
                        @click="deleteParamContab"
                    >

                        <font-awesome-icon
                            :icon="['fas', 'trash']"
                        />

                    </b-button>


                    <!-- CONSULTAR -->
                    <b-button
                        class="consult-btn mx-3"
                        type="button"
                        @click="procesarContabilizacion"
                        :disabled="!fechaContabilizacion"
                    >

                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />

                        {{ labels.consultar }}

                    </b-button>

                </div>

            </div>

        </div>


        <!-- =====================================================
             TABLA NUEVA
        ====================================================== -->
        <div
            v-if="
                lstCuentasFecha?.length === 0 &&
                !showTblNoData
            "
            class="admin-table-block mt-4"
        >

            <CorporateDataTable
                :items="rows"
                :fields="fieldsNew"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="300"
                :table-max-height="500"
                :show-search="false"
                :allow-column-toggle="false"
                :enable-sorting="false"
                :toolbar-disabled="false"
            >

                <!-- TIPO CONTRATO -->
                <template #cell(tipo_contrato)="data">

                    <select
                        :value="data.item.selTipoContrato || ''"
                        class="form-control"
                        @change="
                            data.item.selTipoContrato =
                                $event.target.value
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option
                            v-for="contrato in tipoContrato"
                            :key="contrato.id"
                            :value="contrato.tipo_contrato"
                        >
                            {{ contrato.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- TIPO ACTIVO -->
                <template #cell(tipo_activo)="data">

                    <select
                        :value="data.item.selTipoActivo || ''"
                        class="form-control"
                        @change="
                            data.item.selTipoActivo =
                                $event.target.value
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option
                            v-for="activo in tipoActivo"
                            :key="activo.id"
                            :value="activo.tipo_activo"
                        >
                            {{ activo.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- CAMPO ORIGEN -->
                <template #cell(campo_origen)="data">

                    <select
                        :value="data.item.selCampoOrigen || ''"
                        class="form-control"
                        @change="
                            data.item.selCampoOrigen =
                                $event.target.value
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option value="1">
                            1-Total Valor Canon
                        </option>

                        <option value="2">
                            2-Pasivo Inicial
                        </option>

                        <option value="3">
                            3-Cambio pasivo
                        </option>

                        <option value="4">
                            4-Total Pago Capital
                        </option>

                        <option value="5">
                            5-Total Pago Intereses
                        </option>

                        <option value="6">
                            6-Pasivo Final
                        </option>

                        <option value="7">
                            7-Activo Derecho de uso Bruto
                        </option>

                        <option value="8">
                            8-Total Gasto Amortizacion
                        </option>

                        <option value="9">
                            9-Amortización acumulada
                        </option>

                        <option value="10">
                            10-Baja de Activos
                        </option>

                    </select>

                </template>


                <!-- CENTRO COSTO -->
                <template #cell(centro_costo)="data">

                    <select
                        :value="
                            data.item.selCentroCostos || 0
                        "
                        class="form-control"
                        @change="
                            data.item.selCentroCostos =
                                $event.target.value
                        "
                    >

                        <option value="0">
                            No aplica...
                        </option>

                        <option
                            v-for="cc in centroCostos"
                            :key="cc.id"
                            :value="cc.codigo"
                        >
                            {{ cc.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- CENTRO APLICAR -->
                <template #cell(centro_aplicar)="data">

                    <select
                        :value="
                            data.item.selCentroFijo || ''
                        "
                        class="form-control"
                        @change="
                            data.item.selCentroFijo =
                                $event.target.value
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option value="C">
                            Contrato
                        </option>

                        <option value="F">
                            Fijo
                        </option>

                    </select>

                </template>


                <!-- CUENTA -->
                <template #cell(cuenta)="data">

                    <input
                        :value="
                            data.item.selCuenta || ''
                        "
                        type="text"
                        class="form-control"
                        @input="
                            data.item.selCuenta =
                                $event.target.value
                        "
                    />

                </template>


                <!-- DESCRIPCIÓN -->
                <template #cell(nombre_cuenta)="data">

                    <input
                        :value="
                            data.item.nombre_cuenta || ''
                        "
                        type="text"
                        class="form-control"
                        @input="
                            data.item.nombre_cuenta =
                                $event.target.value
                        "
                    />

                </template>


                <!-- NATURALEZA -->
                <template #cell(naturaleza)="data">

                    <select
                        :value="
                            data.item.selTipoNaturaleza || ''
                        "
                        class="form-control"
                        @change="
                            data.item.selTipoNaturaleza =
                                $event.target.value
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option value="D">
                            Débito
                        </option>

                        <option value="C">
                            Crédito
                        </option>

                    </select>

                </template>


                <!-- ACCIONES -->
                <template #cell(actions)="data">

                    <b-button
                        size="sm"
                        variant="danger"
                        @click="removeRow(data.index)"
                        :disabled="rows.length <= 1"
                    >

                        <font-awesome-icon
                            :icon="['fas', 'trash']"
                        />

                    </b-button>

                </template>

            </CorporateDataTable>


            <!-- BOTONES -->
            <div class="table-actions mt-3">

                <b-button
                    class="btn-secondary mr-2"
                    @click="addRowOrigen"
                >

                    <font-awesome-icon
                        :icon="['fas', 'plus']"
                        class="mr-1"
                    />

                    Agregar Origen

                </b-button>


                <b-button
                    class="btn-primary mr-2"
                    @click="addRow"
                >

                    <font-awesome-icon
                        :icon="['fas', 'plus']"
                        class="mr-1"
                    />

                    Agregar Fila

                </b-button>


                <b-button
                    class="btn-save"
                    @click="saveData"
                >

                    <font-awesome-icon
                        :icon="['fas', 'save']"
                        class="mr-1"
                    />

                    {{ labels.guardar }}

                </b-button>

            </div>

        </div>


        <!-- =====================================================
             TABLA EXISTENTE
        ====================================================== -->
        <div
            v-if="
                lstCuentasFecha?.length >= 1 &&
                !showTblData
            "
            class="admin-table-block mt-4"
        >

            <CorporateDataTable
                :items="lstCuentasFecha"
                :fields="fieldsData"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="400"
                :table-max-height="600"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :toolbar-disabled="false"
            >

                <!-- =============================================
                     TIPO CONTRATO
                ============================================== -->
                <template #cell(tipo_contrato)="data">

                    <select
                        :value="
                            data.item.tipo_contrato || ''
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'tipo_contrato',
                                $event.target.value
                            )
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option
                            v-for="contrato in tipoContrato"
                            :key="contrato.id"
                            :value="contrato.tipo_contrato"
                        >
                            {{ contrato.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     TIPO ACTIVO
                ============================================== -->
                <template #cell(tipo_activo)="data">

                    <select
                        :value="
                            data.item.tipo_activo || ''
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'tipo_activo',
                                $event.target.value
                            )
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option
                            v-for="activo in tipoActivo"
                            :key="activo.id"
                            :value="activo.tipo_activo"
                        >
                            {{ activo.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     CAMPO ORIGEN
                ============================================== -->
                <template #cell(campo_origen)="data">

                    <select
                        :value="
                            data.item.campo_origen || ''
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'campo_origen',
                                $event.target.value
                            )
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option value="1">
                            1-Total Valor Canon
                        </option>

                        <option value="2">
                            2-Pasivo Inicial
                        </option>

                        <option value="3">
                            3-Cambio pasivo
                        </option>

                        <option value="4">
                            4-Total Pago Capital
                        </option>

                        <option value="5">
                            5-Total Pago Intereses
                        </option>

                        <option value="6">
                            6-Pasivo Final
                        </option>

                        <option value="7">
                            7-Activo Derecho de uso Bruto
                        </option>

                        <option value="8">
                            8-Total Gasto Amortizacion
                        </option>

                        <option value="9">
                            9-Amortización acumulada
                        </option>

                        <option value="10">
                            10-Baja de Activos
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     CENTRO COSTO
                ============================================== -->
                <template #cell(centro_costo)="data">

                    <select
                        :value="
                            data.item.codigo_centro_costo ?? 0
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'codigo_centro_costo',
                                $event.target.value
                            )
                        "
                    >

                        <option value="0">
                            No aplica...
                        </option>

                        <option
                            v-for="cc in centroCostos"
                            :key="cc.id"
                            :value="cc.codigo"
                        >
                            {{ cc.descripcion }}
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     CENTRO APLICAR
                ============================================== -->
                <template #cell(centro_aplicar)="data">

                    <select
                        :value="
                            data.item.centro_fijo || 'C'
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'centro_fijo',
                                $event.target.value
                            )
                        "
                    >

                        <option value="C">
                            Contrato
                        </option>

                        <option value="F">
                            Fijo
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     CUENTA
                ============================================== -->
                <template #cell(cuenta)="data">

                    <input
                        :value="
                            data.item.nro_cuenta || ''
                        "
                        type="text"
                        class="form-control"
                        @input="
                            actualizarCampoTabla(
                                data,
                                'nro_cuenta',
                                $event.target.value
                            )
                        "
                    />

                </template>


                <!-- =============================================
                     DESCRIPCIÓN
                ============================================== -->
                <template #cell(nombre_cuenta)="data">

                    <input
                        :value="
                            data.item.nombre_cuenta || ''
                        "
                        type="text"
                        class="form-control"
                        @input="
                            actualizarCampoTabla(
                                data,
                                'nombre_cuenta',
                                $event.target.value
                            )
                        "
                    />

                </template>


                <!-- =============================================
                     NATURALEZA
                ============================================== -->
                <template #cell(naturaleza)="data">

                    <select
                        :value="
                            data.item.naturaleza || ''
                        "
                        class="form-control"
                        @change="
                            actualizarCampoTabla(
                                data,
                                'naturaleza',
                                $event.target.value
                            )
                        "
                    >

                        <option value="">
                            Seleccione...
                        </option>

                        <option value="D">
                            Débito
                        </option>

                        <option value="C">
                            Crédito
                        </option>

                    </select>

                </template>


                <!-- =============================================
                     ACCIONES
                ============================================== -->
                <template #cell(actions)="data">

                    <b-button
                        size="sm"
                        variant="danger"
                        @click="
                            removeNewRow(
                                data.index,
                                data.item.id
                            )
                        "
                        :disabled="
                            lstCuentasFecha.length <= 1
                        "
                    >

                        <font-awesome-icon
                            :icon="['fas', 'trash']"
                        />

                    </b-button>

                </template>

            </CorporateDataTable>


            <!-- BOTONES -->
            <div class="table-actions mt-3">

                <b-button
                    class="btn-primary mr-2"
                    @click="addRowTblData"
                >

                    <font-awesome-icon
                        :icon="['fas', 'plus']"
                        class="mr-1"
                    />

                    Agregar fila

                </b-button>


                <b-button
                    class="btn-save"
                    @click="saveDataInfo"
                >

                    <font-awesome-icon
                        :icon="['fas', 'save']"
                        class="mr-1"
                    />

                    {{ labels.guardar }}

                </b-button>

            </div>

        </div>

    </div>
</template>


<script>

import CentroCostos from '../../../services/CentroCostos'
import TipoActivo from '../../../services/TipoActivo'
import TipoContrato from '../../../services/TipoContrato'
import ParametrosContabilizacion from '../../../services/ParametrosContabilizacion'
import CorporateDataTable from '../../utils/CorporateDataTable.vue'


export default {

    name: 'ParametrosContabilizacion',


    components: {
        CorporateDataTable
    },


    data: () => ({

        fechaContabilizacion: '',

        fechasParamContab: [],

        tipoContrato: [],

        tipoActivo: [],

        centroCostos: [],


        // =====================================================
        // TABLA NUEVA
        // =====================================================

        rows: [
            {
                selTipoContrato: '',
                selTipoActivo: '',
                selCampoOrigen: '',
                selCuenta: '',
                nombre_cuenta: '',
                selTipoNaturaleza: '',
                selCentroCostos: '',
                selCentroFijo: ''
            }
        ],


        // =====================================================
        // TABLA EXISTENTE
        // =====================================================

        lstCuentasFecha: [],

        savedData: [],

        showTblNoData: true,

        showTblData: true,

        showNewContab: false,

        showBtnParamCont: false,

        newFechaContab: ''

    }),


    computed: {

        // =====================================================
        // LABELS
        // =====================================================

        labels() {

            if (
                this.$store.state._language === 'es-ES'
            ) {

                return {

                    title:
                        'Parámetros de contabilización',

                    fechaContabilizacion:
                        'Fecha contabilización',

                    newFechaContab:
                        'Nueva contabilización',

                    consultar:
                        'Consultar',

                    guardar:
                        'Guardar'

                }

            }


            return {

                title:
                    'Accounting parameters',

                fechaContabilizacion:
                    'Posting date',

                newFechaContab:
                    'New posting',

                consultar:
                    'Consult',

                guardar:
                    'Save'

            }

        },


        // =====================================================
        // CAMPOS TABLA NUEVA
        // =====================================================

        fieldsNew() {

            return [

                {
                    key: 'tipo_contrato',
                    label: 'Tipo contrato',
                    sortable: false
                },

                {
                    key: 'tipo_activo',
                    label: 'Tipo activo',
                    sortable: false
                },

                {
                    key: 'campo_origen',
                    label: 'Campo origen',
                    sortable: false
                },

                {
                    key: 'centro_costo',
                    label: 'Centro costo',
                    sortable: false
                },

                {
                    key: 'centro_aplicar',
                    label: 'Centro Aplicar',
                    sortable: false
                },

                {
                    key: 'cuenta',
                    label: 'Cuenta',
                    sortable: false
                },

                {
                    key: 'nombre_cuenta',
                    label: 'Descripción',
                    sortable: false
                },

                {
                    key: 'naturaleza',
                    label: 'Naturaleza',
                    sortable: false
                },

                {
                    key: 'actions',
                    label: 'Acciones',
                    sortable: false
                }

            ]

        },


        // =====================================================
        // CAMPOS TABLA EXISTENTE
        // =====================================================

        fieldsData() {

            return [

                {
                    key: 'tipo_contrato',
                    label: 'Tipo contrato',
                    sortable: true
                },

                {
                    key: 'tipo_activo',
                    label: 'Tipo activo',
                    sortable: true
                },

                {
                    key: 'campo_origen',
                    label: 'Campo origen',
                    sortable: true
                },

                {
                    key: 'centro_costo',
                    label: 'Centro costo',
                    sortable: true
                },

                {
                    key: 'centro_aplicar',
                    label: 'Centro Aplicar',
                    sortable: true
                },

                {
                    key: 'cuenta',
                    label: 'Cuenta',
                    sortable: true
                },

                {
                    key: 'nombre_cuenta',
                    label: 'Descripción',
                    sortable: true
                },

                {
                    key: 'naturaleza',
                    label: 'Naturaleza',
                    sortable: true
                },

                {
                    key: 'actions',
                    label: 'Acciones',
                    sortable: false
                }

            ]

        },


        // =====================================================
        // LABELS TABLA
        // =====================================================

        tableLabels() {

            if (
                this.$store.state._language === 'es-ES'
            ) {

                return {

                    search: 'Buscar',

                    noData: 'No hay datos',

                    noResults:
                        'No se encontraron resultados',

                    perPage:
                        'Registros por página',

                    columns:
                        'Columnas',

                    previous:
                        'Anterior',

                    next:
                        'Siguiente'

                }

            }


            return {

                search: 'Search',

                noData:
                    'No data',

                noResults:
                    'No results found',

                perPage:
                    'Rows per page',

                columns:
                    'Columns',

                previous:
                    'Previous',

                next:
                    'Next'

            }

        }

    },


    methods: {

        // =====================================================
        // VOLVER
        // =====================================================

        goBack() {

            this.$router.back()

        },


        // =====================================================
        // CONSULTAR
        // =====================================================

        procesarContabilizacion() {

            if (!this.fechaContabilizacion) {

                this.$toast.error(
                    'Seleccionar la fecha contabilización.'
                )

                return

            }


            ParametrosContabilizacion
                .getParametrosContabilizacionByFechaContb(
                    this.fechaContabilizacion
                )
                .then((res) => {

                    console.log(
                        'PARAMETROS CONSULTADOS:',
                        res.data
                    )


                    this.lstCuentasFecha =
                        res.data.listParamtsContByFec || []


                    if (
                        this.lstCuentasFecha.length > 0
                    ) {

                        this.showTblData = false

                        this.showTblNoData = true

                    } else {

                        this.showTblNoData = false

                        this.showTblData = true

                    }

                })
                .catch((err) => {

                    console.error(
                        'ERROR CONSULTANDO:',
                        err
                    )

                    this.$toast.error(
                        'Error consultando los parámetros.'
                    )

                })

        },


        // =====================================================
        // CREAR NUEVA FECHA
        // =====================================================

        creaParamContab() {

            if (
                !this.fechasParamContab.length
            ) {

                return

            }


            this.showNewContab = true


            const lastFecha =
                this.fechasParamContab[0]


            ParametrosContabilizacion
                .getParametrosContabilizacionByFechaContb(
                    lastFecha.fecha_contabilizacion
                )
                .then((res) => {

                    this.lstCuentasFecha =
                        res.data.listParamtsContByFec || []


                    this.fechaContabilizacion =
                        lastFecha.fecha_contabilizacion


                    if (
                        this.lstCuentasFecha.length > 0
                    ) {

                        this.showTblData = false

                        this.showTblNoData = true

                    } else {

                        this.showTblNoData = false

                        this.showTblData = true

                    }

                })
                .catch((err) => {

                    console.error(
                        'ERROR OBTENIENDO PLANTILLA:',
                        err
                    )

                })

        },


        // =====================================================
        // CANCELAR NUEVA FECHA
        // =====================================================

        deleteParamContab() {

            this.showNewContab = false

            this.newFechaContab = ''

        },


        // =====================================================
        // CREAR FILA TABLA NUEVA
        // =====================================================

        createEmptyRow() {

            const lastRow =
                this.rows.length
                    ? this.rows[
                        this.rows.length - 1
                    ]
                    : null


            return {

                selTipoContrato:
                    lastRow
                        ? lastRow.selTipoContrato
                        : '',

                selTipoActivo:
                    lastRow
                        ? lastRow.selTipoActivo
                        : '',

                selCampoOrigen:
                    lastRow
                        ? lastRow.selCampoOrigen
                        : '',

                selCuenta: '',

                nombre_cuenta: '',

                selTipoNaturaleza: '',

                selCentroCostos: '',

                selCentroFijo: ''

            }

        },


        // =====================================================
        // AGREGAR FILA TABLA NUEVA
        // =====================================================

        addRow() {

            this.rows.push(
                this.createEmptyRow()
            )

        },


        // =====================================================
        // CREAR FILA ORIGEN
        // =====================================================

        createOriginRow() {

            const lastRow =
                this.rows.length
                    ? this.rows[
                        this.rows.length - 1
                    ]
                    : null


            return {

                selTipoContrato:
                    lastRow
                        ? lastRow.selTipoContrato
                        : '',

                selTipoActivo:
                    lastRow
                        ? lastRow.selTipoActivo
                        : '',

                selCampoOrigen: '',

                selCuenta: '',

                nombre_cuenta: '',

                selTipoNaturaleza: '',

                selCentroCostos: '',

                selCentroFijo: ''

            }

        },


        // =====================================================
        // AGREGAR ORIGEN
        // =====================================================

        addRowOrigen() {

            this.rows.push(
                this.createOriginRow()
            )

        },


        // =====================================================
        // ELIMINAR FILA TABLA NUEVA
        // =====================================================

        removeRow(index) {

            if (
                this.rows.length > 1
            ) {

                this.rows.splice(
                    index,
                    1
                )

            } else {

                this.$toast.error(
                    'Debe haber mínimo una fila'
                )

            }

        },


        // =====================================================
        // AGREGAR FILA A TABLA EXISTENTE
        // =====================================================

        addRowTblData() {

            const newRow = {

                id: null,

                tipo_contrato: '',

                tipo_activo: '',

                campo_origen: '',

                codigo_centro_costo: 0,

                centro_fijo: 'C',

                nro_cuenta: '',

                nombre_cuenta: '',

                naturaleza: '',

                idUser:
                    this.$store.state.userId,

                fecha_contabilizacion:
                    this.fechaContabilizacion

            }


            console.log(
                'NUEVA FILA:',
                newRow
            )


            this.lstCuentasFecha.push(
                newRow
            )

        },


        // =====================================================
        // ACTUALIZAR CAMPO TABLA EXISTENTE
        // =====================================================

        actualizarCampoTabla(
            data,
            campo,
            valor
        ) {

            console.log(
                '================================'
            )

            console.log(
                'ACTUALIZANDO CAMPO:',
                campo
            )

            console.log(
                'VALOR:',
                valor
            )

            console.log(
                'ITEM:',
                data.item
            )


            let registroReal = null


            // =================================================
            // BUSCAR POR ID
            // =================================================

            if (
                data.item?.id !== null &&
                data.item?.id !== undefined
            ) {

                registroReal =
                    this.lstCuentasFecha.find(
                        item =>
                            item.id ===
                            data.item.id
                    )

            }


            // =================================================
            // FILA NUEVA
            // =================================================

            if (!registroReal) {

                /*
                 * Para una fila nueva intentamos encontrar
                 * el mismo objeto por referencia.
                 */

                registroReal =
                    this.lstCuentasFecha.find(
                        item =>
                            item === data.item
                    )

            }


            // =================================================
            // FALLBACK PARA FILA NUEVA
            // =================================================

            if (!registroReal) {

                /*
                 * Si CorporateDataTable está entregando
                 * una copia del objeto, buscamos la última
                 * fila nueva.
                 *
                 * Las filas nuevas tienen id === null.
                 */

                const filasNuevas =
                    this.lstCuentasFecha.filter(
                        item =>
                            item.id === null ||
                            item.id === undefined
                    )


                if (
                    filasNuevas.length > 0
                ) {

                    registroReal =
                        filasNuevas[
                            filasNuevas.length - 1
                        ]

                }

            }


            // =================================================
            // ACTUALIZAR
            // =================================================

            if (registroReal) {

                registroReal[campo] = valor


                console.log(
                    'REGISTRO ACTUALIZADO:',
                    registroReal
                )

                console.log(
                    'CAMPO:',
                    campo
                )

                console.log(
                    'VALOR FINAL:',
                    registroReal[campo]
                )

            } else {

                console.error(
                    'NO SE ENCONTRÓ EL REGISTRO'
                )

                console.error(
                    'DATA:',
                    data
                )

                console.error(
                    'LISTA:',
                    this.lstCuentasFecha
                )

            }


            console.log(
                '================================'
            )

        },


        // =====================================================
        // ELIMINAR REGISTRO
        // =====================================================

        removeNewRow(
            index,
            id
        ) {

            if (
                this.lstCuentasFecha.length <= 1
            ) {

                this.$toast.error(
                    'Debe haber mínimo una fila'
                )

                return

            }


            // REGISTRO EXISTENTE
            if (
                id !== null &&
                id !== undefined
            ) {

                ParametrosContabilizacion
                    .deleteParametrosContabilizacion(id)
                    .then((res) => {

                        this.$toast.success(
                            res.data.message
                        )


                        this.lstCuentasFecha.splice(
                            index,
                            1
                        )

                    })
                    .catch((err) => {

                        console.error(
                            'ERROR ELIMINANDO:',
                            err
                        )

                        this.$toast.error(
                            'No fue posible eliminar el registro.'
                        )

                    })

            } else {

                // FILA NUEVA
                this.lstCuentasFecha.splice(
                    index,
                    1
                )

            }

        },


        // =====================================================
        // GUARDAR TABLA NUEVA
        // =====================================================

        saveData() {

            if (!this.fechaContabilizacion) {

                this.$toast.error(
                    'Seleccionar la fecha contabilización.'
                )

                return

            }


            const camposObligatorios = [

                {
                    campo: 'selTipoContrato',
                    nombre: 'Tipo contrato'
                },

                {
                    campo: 'selTipoActivo',
                    nombre: 'Tipo activo'
                },

                {
                    campo: 'selCampoOrigen',
                    nombre: 'Campo origen'
                },

                {
                    campo: 'selCuenta',
                    nombre: 'Cuenta'
                },

                {
                    campo: 'nombre_cuenta',
                    nombre: 'Descripción'
                },

                {
                    campo: 'selTipoNaturaleza',
                    nombre: 'Naturaleza'
                }

            ]


            // =================================================
            // VALIDAR
            // =================================================

            for (
                let i = 0;
                i < this.rows.length;
                i++
            ) {

                const row =
                    this.rows[i]


                for (
                    const campo
                    of camposObligatorios
                ) {

                    const valor =
                        row[campo.campo]


                    if (
                        valor === null ||
                        valor === undefined ||
                        String(valor).trim() === ''
                    ) {

                        this.$toast.error(
                            `Fila ${i + 1}: falta diligenciar "${campo.nombre}".`
                        )

                        return

                    }

                }

            }


            // =================================================
            // PREPARAR DATOS
            // =================================================

            const formattedData =
                this.rows.map(row => {

                    return {

                        tipo_contrato:
                            row.selTipoContrato,

                        tipo_activo:
                            row.selTipoActivo,

                        campo_origen:
                            row.selCampoOrigen,

                        codigo_centro_costo:
                            row.selCentroCostos || 0,

                        centro_fijo:
                            row.selCentroFijo,

                        nro_cuenta:
                            row.selCuenta,

                        nombre_cuenta:
                            row.nombre_cuenta,

                        naturaleza:
                            row.selTipoNaturaleza,

                        idUser:
                            this.$store.state.userId,

                        fecha_contabilizacion:
                            this.fechaContabilizacion

                    }

                })


            console.log(
                'DATOS A GUARDAR:',
                JSON.stringify(
                    formattedData,
                    null,
                    2
                )
            )


            ParametrosContabilizacion
                .createParametrosContabilizacion(
                    formattedData
                )
                .then((res) => {

                    console.log(
                        'RESPUESTA GUARDAR:',
                        res.data
                    )

                    this.$toast.success(
                        res.data.message
                    )

                    location.reload()

                })
                .catch((err) => {

                    console.error(
                        'ERROR GUARDANDO:',
                        err
                    )

                    console.error(
                        'RESPUESTA BACKEND:',
                        err.response?.data
                    )


                    this.$toast.error(
                        err.response?.data?.message ||
                        'Algo pasó, inténtalo de nuevo'
                    )

                })

        },


        // =====================================================
        // ACTUALIZAR EXISTENTES / CREAR NUEVOS
        // =====================================================

        saveDataInfo() {

            // =================================================
            // NUEVA FECHA
            // =================================================

            if (
                this.fechaContabilizacion &&
                this.newFechaContab
            ) {

                this.guardarContabilizacion()

                return

            }


            // =================================================
            // VALIDAR LISTA
            // =================================================

            if (
                !this.lstCuentasFecha ||
                this.lstCuentasFecha.length === 0
            ) {

                this.$toast.error(
                    'Debe agregar mínimo un registro.'
                )

                return

            }


            const camposObligatorios = [

                {
                    campo: 'tipo_contrato',
                    nombre: 'Tipo contrato'
                },

                {
                    campo: 'tipo_activo',
                    nombre: 'Tipo activo'
                },

                {
                    campo: 'campo_origen',
                    nombre: 'Campo origen'
                },

                {
                    campo: 'nro_cuenta',
                    nombre: 'Cuenta'
                },

                {
                    campo: 'nombre_cuenta',
                    nombre: 'Descripción'
                },

                {
                    campo: 'naturaleza',
                    nombre: 'Naturaleza'
                }

            ]


            // =================================================
            // VALIDAR CADA REGISTRO
            // =================================================

            for (
                let i = 0;
                i < this.lstCuentasFecha.length;
                i++
            ) {

                const row =
                    this.lstCuentasFecha[i]


                for (
                    const campo
                    of camposObligatorios
                ) {

                    const valor =
                        row[campo.campo]


                    if (
                        valor === null ||
                        valor === undefined ||
                        String(valor).trim() === ''
                    ) {

                        console.error(
                            '================================'
                        )

                        console.error(
                            'FILA INCOMPLETA:',
                            i + 1
                        )

                        console.error(
                            'CAMPO:',
                            campo.nombre
                        )

                        console.error(
                            'REGISTRO:',
                            row
                        )

                        console.error(
                            '================================'
                        )


                        this.$toast.error(
                            `Fila ${i + 1}: falta diligenciar "${campo.nombre}".`
                        )

                        return

                    }

                }

            }


            // =================================================
            // PREPARAR DATOS
            // =================================================

            const datos =
                this.lstCuentasFecha.map(row => {

                    return {

                        id:
                            row.id !== null &&
                            row.id !== undefined
                                ? row.id
                                : null,

                        tipo_contrato:
                            row.tipo_contrato,

                        tipo_activo:
                            row.tipo_activo,

                        campo_origen:
                            row.campo_origen,

                        codigo_centro_costo:
                            row.codigo_centro_costo || 0,

                        centro_fijo:
                            row.centro_fijo || 'C',

                        nro_cuenta:
                            row.nro_cuenta,

                        nombre_cuenta:
                            row.nombre_cuenta,

                        naturaleza:
                            row.naturaleza,

                        idUser:
                            row.idUser ||
                            this.$store.state.userId,

                        fecha_contabilizacion:
                            row.fecha_contabilizacion ||
                            this.fechaContabilizacion

                    }

                })


            console.log(
                '======================================'
            )

            console.log(
                'DATOS A ACTUALIZAR / CREAR:'
            )

            console.log(
                JSON.stringify(
                    datos,
                    null,
                    2
                )
            )

            console.log(
                '======================================'
            )


            // =================================================
            // ENVIAR AL BACKEND
            // =================================================

            ParametrosContabilizacion
                .updateCreateParametrosContabilizacion(
                    datos
                )
                .then((res) => {

                    console.log(
                        'RESPUESTA BACKEND:',
                        res.data
                    )

                    this.$toast.success(
                        res.data.message
                    )

                    location.reload()

                })
                .catch((err) => {

                    console.error(
                        'ERROR ACTUALIZANDO / CREANDO:',
                        err
                    )

                    console.error(
                        'RESPUESTA BACKEND:',
                        err.response?.data
                    )


                    this.$toast.error(
                        err.response?.data?.message ||
                        'Algo pasó, inténtalo de nuevo'
                    )

                })

        },


        // =====================================================
        // CREAR NUEVA FECHA
        // =====================================================

        guardarContabilizacion() {

            if (!this.newFechaContab) {

                this.$toast.error(
                    'Seleccionar la nueva fecha contabilización.'
                )

                return

            }


            const lastFecha =
                this.fechasParamContab[0]


            if (!lastFecha) {

                this.$toast.error(
                    'No existe una fecha anterior para copiar.'
                )

                return

            }


            const info = {

                newFechaParCon:
                    this.newFechaContab,

                lastFechaParCon:
                    lastFecha.fecha_contabilizacion,

                idUser:
                    this.$store.state.userId

            }


            console.log(
                'NUEVA FECHA:',
                info
            )


            ParametrosContabilizacion
                .cargaLastPlantilla(info)
                .then((res) => {

                    console.log(
                        'RESPUESTA NUEVA FECHA:',
                        res.data
                    )

                    this.$toast.success(
                        res.data.message
                    )

                    location.reload()

                })
                .catch((err) => {

                    console.error(
                        'ERROR NUEVA FECHA:',
                        err
                    )

                    this.$toast.error(
                        err.response?.data?.message ||
                        'Error creando nueva fecha'
                    )

                })

        },


        // =====================================================
        // CARGAR TIPOS DE CONTRATO
        // =====================================================

        listTipoContrato() {

            TipoContrato
                .getAllTipoContrato()
                .then((res) => {

                    this.tipoContrato =
                        res.data.listTipoContrato || []

                })
                .catch((err) => {

                    console.error(
                        'ERROR TIPO CONTRATO:',
                        err
                    )

                })

        },


        // =====================================================
        // CARGAR TIPOS DE ACTIVO
        // =====================================================

        listTipoActivo() {

            TipoActivo
                .getAllTipoActivo()
                .then((res) => {

                    this.tipoActivo =
                        res.data.listTipoActivo || []

                })
                .catch((err) => {

                    console.error(
                        'ERROR TIPO ACTIVO:',
                        err
                    )

                })

        },


        // =====================================================
        // CARGAR CENTROS DE COSTO
        // =====================================================

        listCentroCosto() {

            CentroCostos
                .getAllCentroCostos()
                .then((res) => {

                    this.centroCostos =
                        res.data.listCentroCostos || []

                })
                .catch((err) => {

                    console.error(
                        'ERROR CENTRO COSTO:',
                        err
                    )

                })

        }

    },


    // =========================================================
    // MOUNTED
    // =========================================================

    mounted() {

        this.listTipoContrato()

        this.listTipoActivo()

        this.listCentroCosto()


        ParametrosContabilizacion
            .getAllFechasParametrosContabilizacion()
            .then((res) => {

                console.log(
                    'FECHAS PARAMETRIZADAS:',
                    res.data
                )

                this.fechasParamContab =
                    res.data.lstFechParamContab || []

            })
            .catch((err) => {

                console.error(
                    'ERROR FECHAS:',
                    err
                )

            })

    },


    // =========================================================
    // WATCH
    // =========================================================

    watch: {

        fechaContabilizacion(valNew) {

            if (!valNew) {

                this.lstCuentasFecha = []

                this.showNewContab = false

                return

            }


            const lastFecha =
                this.fechasParamContab?.[0]


            if (
                lastFecha &&
                valNew < lastFecha.fecha_contabilizacion
            ) {

                this.showNewContab = false

                this.newFechaContab = ''


                ParametrosContabilizacion
                    .getParametrosContabilizacionByFechaContb(
                        valNew
                    )
                    .then((res) => {

                        this.lstCuentasFecha =
                            res.data.listParamtsContByFec || []


                        if (
                            this.lstCuentasFecha.length > 0
                        ) {

                            this.showTblData = false

                            this.showTblNoData = true

                        } else {

                            this.showTblNoData = false

                            this.showTblData = true

                        }

                    })
                    .catch((err) => {

                        console.error(
                            'ERROR CONSULTANDO FECHA:',
                            err
                        )

                    })

            }

        }

    }

}

</script>


<style scoped>

.table-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}


::v-deep .corporate-data-table select,
::v-deep .corporate-data-table input {
    min-width: 130px;
    height: 36px;
}


::v-deep .corporate-data-table thead th {
    white-space: nowrap !important;
}


::v-deep .corporate-data-table {
    width: 100%;
}


::v-deep .corporate-data-table td {
    vertical-align: middle;
}


::v-deep .corporate-data-table-wrapper {
    overflow-x: auto;
}


.table-toolbar-add-btn {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    border: none;
    background-color: #2e507a;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}


.table-toolbar-delete-btn {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    border: none;
    background-color: #d80027;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}


.btn-save {
    background-color: #2c3e50;
    color: white;
    border: none;
    padding: 9px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
}


.btn-save:hover {
    background-color: #1c2127;
}


.btn-primary {
    background-color: #2e507a;
    border-color: #2e507a;
}


.btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
}


.fecha-input-wrapper {
    position: relative;
    width: 210px;
    margin: 0 15px;
}


.fecha-input-wrapper .form-control {
    width: 100%;
    height: 38px;
}


.fecha-placeholder {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #212529;
    background: white;
    padding: 0 4px;
    pointer-events: none;
    font-size: 14px;
}

</style>